.preview-container {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    border: 1px solid var(--form-border);
    background: var(--off-white);
    border-radius: 3px;
}

.host-section-container {
    background-color: var(--off-white);
    padding: 16px;
    border-radius: 3px;
    color: var(--grey-lt);
    font-size: 13px;
}

.availability-container {
    background: var(--off-white);
    padding: 16px;
    border-radius: 3px;
}

.label-warning {
    display: flex;
    align-items: center;
}

.label-warning > :first-child {
    margin-right: 4px;
}
